const initialState = {
    notices: [],
    unreadCount: 0
}

const noticeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_UNREAD_NOTICES_COUNT':
            return {
                ...state,
                unreadCount: action.unreadCount
            }
        case 'GET_MY_NOTICES':
            return {
                ...state,
                notices: action.notices,
                unreadCount: action.unreadCount
            }
        case 'MARK_NOTICE_AS_READ':
            const updatedNotices = state.notices.map(notice => {
                if (Number(notice.id) === Number(action.noticeId)) {
                    return { ...notice, is_read: true }
                }
                return notice
            })
            
            // Calculate new unread count from the updated list
            const newUnreadCount = Math.max(0, state.unreadCount - 1)
            
            return {
                ...state,
                notices: updatedNotices,
                unreadCount: newUnreadCount
            }
        default:
            return state
    }
}

export default noticeReducer
